import parse from 'html-react-parser';
import React from 'react';
import { FreeText } from '../redux/types';

type Props = {
    freeText: FreeText[];
};

const DealFreeText: React.FC<Props> = ({ freeText }) => {
    return (
        <>
            {freeText.map((f) => (
                <div className=" font-[Lato]  py-6 summary pb-2" key={f.uuid}>
                    {parse(f.text)}
                </div>
            ))}
        </>
    );
};

export default DealFreeText;
